<div class="aifc-toolbar-bar">
<div class="aifc-toolbar">
  <button
    class="aifc-burger"
    type="button"
    (click)="toggleMobileMenu()"
    [attr.aria-expanded]="isMobileMenuOpen"
    aria-label="Menu"
  >
    <span nz-icon [nzType]="isMobileMenuOpen ? 'close' : 'menu'"></span>
  </button>

  <a class="aifc-logo" routerLink="/">
    <img src="assets/images/aifc-logo.png" alt="AIFC" />
  </a>

  <span class="aifc-spacer"></span>

  <nav class="aifc-nav">
    <a
      *ngFor="let item of navItems"
      class="aifc-nav__item"
      [class.active]="isActive(item)"
      (click)="navigate(item)"
    >
      {{ item.labelKey | translate }}
    </a>

    <a
      *ngIf="navDropdown"
      class="aifc-nav__item"
      [class.active]="isDropdownActive"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="marketplacesMenu"
    >
      {{ navDropdown.labelKey | translate }}
      <span nz-icon nzType="down" class="aifc-nav__caret"></span>
    </a>
  </nav>

  <span class="aifc-spacer"></span>

  <div class="aifc-actions">
    <ng-content select="[headerActions]"></ng-content>

    <button
      class="aifc-lang"
      type="button"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="languageMenu"
    >
      {{ currentLang.name }}
      <span nz-icon nzType="down"></span>
    </button>

    <button
      *ngIf="showNotifications"
      class="aifc-bell"
      type="button"
      routerLink="/portal/notifications"
      [attr.aria-label]="'Notifications' | translate"
    >
      <span nz-icon nzType="bell"></span>
      <nz-badge
        *ngIf="notificationCount > 0"
        class="aifc-bell__badge"
        [nzCount]="notificationCount"
        [nzOverflowCount]="99"
        nzSize="small"
      ></nz-badge>
    </button>

    <button *ngIf="!isAuthenticated" class="aifc-login" type="button" (click)="login()">
      {{ "Login" | translate }}
    </button>

    <div
      *ngIf="isAuthenticated"
      class="aifc-avatar"
      nz-dropdown
      nzTrigger="click"
      nzPlacement="bottomRight"
      [nzDropdownMenu]="userMenu"
    >
      <span nz-icon nzType="user"></span>
    </div>
  </div>
</div>
</div>

<!-- Mobile: an overlay drawer sliding in from the left, matching aifc-portal's
     `vex-sidenav` (mat-sidenav mode="over") — dark theme, own header with the
     logo, no visible close button (closes via the backdrop or the burger). -->
<div class="aifc-nav-mobile-backdrop" *ngIf="isMobileMenuOpen" (click)="toggleMobileMenu()"></div>

<nav class="aifc-nav-mobile" [class.aifc-nav-mobile--open]="isMobileMenuOpen">
  <div class="aifc-nav-mobile__header">
    <img src="assets/images/aifc-logo.png" alt="AIFC" class="aifc-nav-mobile__logo" />
  </div>

  <div class="aifc-nav-mobile__list">
    <a
      *ngFor="let item of navItems"
      class="aifc-nav-mobile__item"
      [class.active]="isActive(item)"
      (click)="navigate(item)"
    >
      <span *ngIf="item.icon" nz-icon [nzType]="item.icon" class="aifc-nav-mobile__icon"></span>
      <span class="aifc-nav-mobile__label">{{ item.labelKey | translate }}</span>
    </a>

    <!-- Inline accordion — mirrors aifc-portal's vex-sidenav-item: collapsed by
         default, toggled open in place rather than shown flat. -->
    <ng-container *ngIf="navDropdown">
      <a
        class="aifc-nav-mobile__item aifc-nav-mobile__item--toggle"
        [class.active]="isMobileDropdownOpen || isDropdownActive"
        (click)="toggleMobileDropdown()"
      >
        <span *ngIf="navDropdown.icon" nz-icon [nzType]="navDropdown.icon" class="aifc-nav-mobile__icon"></span>
        <span class="aifc-nav-mobile__label">{{ navDropdown.labelKey | translate }}</span>
        <span
          nz-icon
          nzType="right"
          class="aifc-nav-mobile__chevron"
          [class.aifc-nav-mobile__chevron--open]="isMobileDropdownOpen"
        ></span>
      </a>
      <ng-container *ngIf="isMobileDropdownOpen">
        <a
          *ngFor="let child of navDropdown.children"
          class="aifc-nav-mobile__item aifc-nav-mobile__item--nested"
          (click)="navigate(child)"
        >
          <span class="aifc-nav-mobile__label">{{ child.labelKey | translate }}</span>
        </a>
      </ng-container>
    </ng-container>
  </div>
</nav>

<nz-dropdown-menu #marketplacesMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item *ngFor="let child of navDropdown?.children" (click)="navigate(child)">
      {{ child.labelKey | translate }}
    </li>
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #languageMenu="nzDropdownMenu">
  <ul nz-menu>
    <li
      nz-menu-item
      *ngFor="let lang of languages"
      [nzSelected]="lang.code === currentLang.code"
      (click)="setLang(lang)"
    >
      {{ lang.name }}
    </li>
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="aifc-user-menu">
    <div class="aifc-user-menu__header">
      <span class="aifc-user-menu__avatar"><span nz-icon nzType="user"></span></span>
      <span class="aifc-user-menu__name">{{ userName }}</span>
    </div>

    <ng-container *ngFor="let entry of userMenuItems">
      <button
        *ngIf="entry.routerLink; else externalMenuItem"
        type="button"
        class="aifc-user-menu__item"
        (click)="goTo(entry.routerLink)"
      >
        <span nz-icon [nzType]="entry.icon" class="aifc-user-menu__icon"></span>
        <span>{{ entry.labelKey | translate }}</span>
        <span nz-icon nzType="right" class="aifc-user-menu__chevron"></span>
      </button>

      <!-- Раздел живёт на aifc-portal — уходим туда целиком. -->
      <ng-template #externalMenuItem>
        <button
          *ngIf="entry.externalPath; else inertMenuItem"
          type="button"
          class="aifc-user-menu__item"
          (click)="goToExternal(entry.externalPath)"
        >
          <span nz-icon [nzType]="entry.icon" class="aifc-user-menu__icon"></span>
          <span>{{ entry.labelKey | translate }}</span>
          <span nz-icon nzType="right" class="aifc-user-menu__chevron"></span>
        </button>
      </ng-template>

      <!-- Раздел показываем, но вести пока некуда: кнопка отключена, а не скрыта,
           чтобы состав меню не менялся от сборки к сборке. -->
      <ng-template #inertMenuItem>
        <div class="aifc-user-menu__item aifc-user-menu__item--inert" aria-disabled="true">
          <span nz-icon [nzType]="entry.icon" class="aifc-user-menu__icon"></span>
          <span>{{ entry.labelKey | translate }}</span>
          <span nz-icon nzType="right" class="aifc-user-menu__chevron"></span>
        </div>
      </ng-template>
    </ng-container>

    <!-- Личные кабинеты администраторов aifc-portal — только те, на которые
         у пользователя есть роль (см. buildAdminMenuItems). Внутренний раздел
         (routerLink) уходит роутером, внешний (externalPath) — на aifc-portal. -->
    <ng-container *ngFor="let admin of adminMenuItems">
      <button
        *ngIf="admin.routerLink; else externalAdminItem"
        type="button"
        class="aifc-user-menu__item"
        (click)="goTo(admin.routerLink)"
      >
        <span nz-icon [nzType]="admin.icon" class="aifc-user-menu__icon"></span>
        <span>{{ admin.labelKey | translate }}</span>
        <span nz-icon nzType="right" class="aifc-user-menu__chevron"></span>
      </button>

      <ng-template #externalAdminItem>
        <button
          *ngIf="admin.externalPath"
          type="button"
          class="aifc-user-menu__item"
          (click)="goToExternal(admin.externalPath)"
        >
          <span nz-icon [nzType]="admin.icon" class="aifc-user-menu__icon"></span>
          <span>{{ admin.labelKey | translate }}</span>
          <span nz-icon nzType="right" class="aifc-user-menu__chevron"></span>
        </button>
      </ng-template>
    </ng-container>

    <button
      type="button"
      class="aifc-user-menu__item aifc-user-menu__item--logout"
      (click)="logout()"
    >
      <span nz-icon nzType="logout"></span>
      <span>{{ "Log out" | translate }}</span>
    </button>
  </div>
</nz-dropdown-menu>
